import styled from 'styled-components';
import { Constants } from '@shared/ui-components';


export const TOOLTIP_CLASSNAME = 'ag-tooltip';

const ModalRoot = styled.div`
  ${`.${TOOLTIP_CLASSNAME}`} {
    position: fixed;
    transform: translate(-50%, -30px);
    animation: ${Constants.Animations.slowTopAppearWithXPosition('-50%' as any, -10, -30)} ${p => p.theme.duration.m};
    background-color: ${props => props.theme.color.background};
    color: ${props => props.theme.color.mainFont};
    font-size: 12px;
    line-height: 14px;
    padding: 8px 30px;
    box-shadow: ${props => props.theme.shadow.xl};
    border-radius: 15px;
  }
`;

export const Styled = {
  ModalRoot,
};
